import { render, staticRenderFns } from "./TuitionRegistrationStudent.vue?vue&type=template&id=8523dce0&"
import script from "./TuitionRegistrationStudent.vue?vue&type=script&lang=js&"
export * from "./TuitionRegistrationStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports